import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function EmailIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 20 14"
        {...props}
      >
        <path d="M19.6.81c0-.05-.06-.11-.1-.15h-.05C19.08.25 18.55.01 18 0H2C.9 0 0 .9 0 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-.43-.14-.85-.4-1.19m-2 .69-7.53 7.79L2.26 1.5zM1.5 11.44V2.86l4.29 4.29zm1.06 1.06 4.3-4.29 2.68 2.68c.14.14.33.22.53.22s.39-.08.53-.23l2.57-2.64 4.26 4.26zm15.94-1.06-4.28-4.28 4.28-4.4z" />
      </svg>
    </Icon>
  )
}
export default EmailIcon
